import { render } from "./TableSqlEditor.vue?vue&type=template&id=60f20266"
import script from "./TableSqlEditor.vue?vue&type=script&lang=js"
export * from "./TableSqlEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__